export default {
  lang: "语言",
  start: "开始",
  end: "结束",
  download: "下载",
  reset: "重置",
  downloadFile: "下载文件",
  close: "关闭",
  downloadDocument: "预览操作手册",
  downloadProgress: "下载进度",
  rightClickPreview: "右键点击预览",
  downloadTips: '文件正在下载中，请耐心等待。您可以在下方查看每个文件的下载进度。下载完成后文件将自动保存。',
  undo: "撤销",
  redo: "重做",
  toggleMapType: "切换地图类型",
  fullscreen: "全屏",
  exitFullscreen: "退出全屏",
  selectStartPoint: "选择起点",
  selectEndPoint: "选择终点",
  pointInfo: "点位信息",
  startPointInfo: "起点信息",
  endPointInfo: "终点信息",
  time: "时间",
  longitude: "经度",
  latitude: "纬度",
  deleteStartPoint: "删除起点",
  deleteEndPoint: "删除终点",
  confirmDeleteStart: "确定要删除起点吗？",
  confirmDeleteEnd: "确定要删除终点吗？",
  pointDeleted: "点位已删除",
  startPointDeleted: "起点已删除",
  endPointDeleted: "终点已删除",
  clickToSelect: "点击选择该点位",
  confirmRange: "请问您是否确定选取这个范围?",
  cancel: "取消",
  confirm: "确定",
  mapLoaded: "地图加载完成",
  browserNotSupported: "请在chrome、safari、IE8+以上浏览器查看本示例",
  // 文件点过滤模态框
  filePointFilterTitle: "您所需要打点分割的rosbag包文件夹为",
  selectAll: "全选",
  deselectAll: "取消全选",
  // 消息提示
  operationUndone: "已撤销上一步操作",
  operationRedone: "已重做操作",
  selectionCancelled: "已取消选择",
  newStartPointSelected: "已选择新的起点",
  endPointSelected: "已选择终点",
  // 文件下载消息
  downloadError: "下载失败",
  downloadSuccess: "下载完成",
  replicatingSuccess: "复制成功",
  cancelAll: "取消全部",
  downloadCancelled: "下载已取消",
  downloadCompleted: "下载完成",
  downloadFailed: "下载失败"
}